import React, { useEffect, useState } from "react";
import { Fragment } from "react";

import Fade from "react-reveal/Fade";
import { Table } from "antd";

function FMRTable() {
  const columns = [
    {
      title: "Fund Manger Reports",
      dataIndex: "name",
    },
    // {
    //   title: "Offer Price (Rs.)",
    //   dataIndex: "offerPrice",
    // },
    {
      title: "Details",
      dataIndex: "headtonav",
    },
  ];
  const data = [
    {
      key: "1",
      name: "SFTL Fund Manager Report June 2024",
      headtonav: (
        <a
          href={`${process.env.REACT_APP_ASSETS_URL}Assets/pdf/FmrJune.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          View Detail
        </a>
      ),
    },
    {
      key: "2",
      name: "SFTL Fund Manager Report July 2024",
      headtonav: (
        <a
          href={`${process.env.REACT_APP_ASSETS_URL}Assets/pdf/FmrJuly.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          View Detail
        </a>
      ),
    },
    {
      key: "3",
      name: "SFTL Fund Manager Report August 2024",
      headtonav: (
        <a
          href={`${process.env.REACT_APP_ASSETS_URL}Assets/pdf/fmrAugust.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          View Detail
        </a>
      ),
    },
    {
      key: "4",
      name: "SFTL Fund Manager Report September 2024",
      headtonav: (
        <a
          href={`${process.env.REACT_APP_ASSETS_URL}Assets/pdf/fmrSeptember.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          View Detail
        </a>
      ),
    },
    {
      key: "5",
      name: "SFTL Fund Manager Report October 2024",
      headtonav: (
        <a
          href={`${process.env.REACT_APP_ASSETS_URL}Assets/pdf/fmrOctober.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          View Detail
        </a>
      ),
    },
    {
      key: "6",
      name: "SFTL Fund Manager Report November 2024",
      headtonav: (
        <a
          href={`${process.env.REACT_APP_ASSETS_URL}Assets/pdf/fmrNovember.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          View Detail
        </a>
      ),
    },
    {
      key: "7",
      name: "SFTL Fund Manager Report December 2024",
      headtonav: (
        <a
          href={`${process.env.REACT_APP_ASSETS_URL}Assets/pdf/fmrDecember.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          View Detail
        </a>
      ),
    },
    {
      key: "8",
      name: "SFTL Fund Manager Report January 2025",
      headtonav: (
        <a
          href={`${process.env.REACT_APP_ASSETS_URL}Assets/pdf/FMRJan.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          View Detail
        </a>
      ),
    },
  ];

  const generateData = () => {
    const currentDate = new Date();
    // Set to the last day of previous month
    currentDate.setMonth(currentDate.getMonth() - 1);
    const startDate = new Date(2024, 5); // June 2024 (months are 0-indexed)
    const generatedData = [];

    let currentMonth = new Date(startDate);


    
    while (currentMonth <= currentDate) {
      debugger
      const validateCurrentDate = `${currentDate.getMonth()}-${currentDate.getFullYear()}` 
      const validateCurrentMonth = `${currentMonth.getMonth()}-${currentMonth.getFullYear()}` 

      if (
        validateCurrentDate == validateCurrentMonth
          && currentDate.getDate() < process.env.REACT_APP_FMR_GENERATION_DAY) {
        break
      }

      const monthName = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
        currentMonth
      );
      const year = currentMonth.getFullYear();
      
      const entry = {
        key: generatedData.length + 1,
        name: `SFTL Fund Manager Report ${monthName} ${year}`,
        headtonav: (
          <a
            href={`${process.env.REACT_APP_ASSETS_URL}Assets/pdf/FMR${monthName}${year}.pdf`}
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            View Detail
          </a>
        ),
      };

      generatedData.push(entry);
      currentMonth.setMonth(currentMonth.getMonth() + 1);
    }

    return generatedData;
  };

  // Update your component to use the generated data
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const generatedData = generateData();
    setTableData(generatedData);
  }, []);

  return (
    <Fragment>
      <div className="sub complainforms whistleforms fundPrices">
        <div className="row">
          <div className="col-sm-12 formstyle rightform">
            <Fade down delay={500}>
              <Table
                columns={columns}
                dataSource={tableData}
                pagination={false}
                bordered
                summary={(pageData) => {
                  let totalBorrow = 0;
                  let totalRepayment = 0;
                  pageData.forEach(({ borrow, repayment }) => {
                    totalBorrow += borrow;
                    totalRepayment += repayment;
                  });
                  return (
                    <>
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={1}></Table.Summary.Cell>
                      </Table.Summary.Row>
                    </>
                  );
                }}
              />
            </Fade>
          </div>
        </div>
        {/* Display success message at the bottom */}
      </div>
    </Fragment>
  );
}

export default FMRTable;
